import Stack from '@mui/material/Stack';
import React from 'react';
import ResourceTreeView from './ResourceTreeView';
import { Button, Divider } from '@mui/material';
import { COLOR_BG_SECONDARY, COLOR_BORDER_PRIMARY } from './theme';
import { useDispatch, useSelector } from 'react-redux';
import { renderIcon } from './renderIcon';
import { Icon } from '../core/icon';
import { css } from '@emotion/css';
import ProjectDetailsView from './ProjectDetailsView';
import { useServices } from './ServiceProvider';
const getNavStyle = (isNavBarVisible) => ({
    backgroundColor: COLOR_BG_SECONDARY,
    borderRight: isNavBarVisible ? `1px solid ${COLOR_BORDER_PRIMARY}` : undefined,
    minWidth: isNavBarVisible ? '250px' : undefined,
});
const DrawerControl = () => {
    const { ResourceTreeService } = useServices();
    const dispatch = useDispatch();
    const isNavBarVisible = useSelector(ResourceTreeService.selectors.isVisible);
    const icon = isNavBarVisible ? Icon.DRAWER_CLOSE : Icon.DRAWER_OPEN;
    return (React.createElement(Button, { onClick: () => dispatch(ResourceTreeService.actions.toggleVisible()), sx: { borderRight: `1px solid ${COLOR_BORDER_PRIMARY}`, minWidth: '40px', maxWidth: '40px' }, startIcon: renderIcon(icon, { sx: { color: 'white', marginRight: '-10px' } }) }));
};
const NavBar = () => {
    const { ResourceTreeService } = useServices();
    const isNavBarVisible = useSelector(ResourceTreeService.selectors.isVisible);
    return (React.createElement(Stack, { direction: "row", sx: getNavStyle(isNavBarVisible) },
        React.createElement(DrawerControl, null),
        isNavBarVisible && (React.createElement(Stack, { flexGrow: "1" },
            React.createElement(ProjectDetailsView, null),
            React.createElement(Divider, null),
            React.createElement(ResourceTreeView, { className: css({ flexGrow: '1' }) })))));
};
export default NavBar;
//# sourceMappingURL=NavBar.js.map